module.exports = __webpack_public_path__ + "img/peterbilt_thumbnail.98e0a41b.png";